import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationTemplate/<status>';

export function useAutomationTemplatesByStatusQuery({
	status,
	meta,
}: {
	status: Api.TemplateStatus;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationTemplate`,
					queryParams: { status },
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, status],
		meta,
	});
}
